import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'mlp-ng-button-atom',
    templateUrl: './button-atom.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ButtonAtomSharedComponent {
    @Input() btnShadow = false;
    @Input() btnSize: 'large' | 'medium' | 'xsmall' | 'small' = 'medium';
    @Input() btnStyle: 'secondary' | 'tertiary';
    @Input() btnType: 'submit' | 'button' | 'reset' = 'button';
    @Input() disabled = false;
    @Input() fullWidth = false;
    @Input() label: string;
    @Input() labelSecondary: string;
}
